import React, { FC } from 'react';
import { Input, Button, Checkbox } from 'antd';
import { usePublicFeedbackState } from '../../../providers/PublicFeedback';
import { translations } from '../strings';
import cx from 'classnames';
import styles from './index.module.css';

type Props = {};

const DESCRIPTION_CHARACTER_LIMIT: number = 2000;

const CreateTask: FC<Props> = () => {
  const {
    locale,
    onDescriptionChange,
    description,
    onEmailChange,
    onCheckboxChange,
    submitEnabled,
    submitTask,
    reporterEmail,
    email,
    privacyChecked
  } = usePublicFeedbackState();

  const strings = translations(locale);

  return (
    <>
      <div className={styles.descriptionContainer}>
        <Input.TextArea
          value={description}
          onChange={onDescriptionChange}
          placeholder={strings.feedback_entry_placeholder}
          autoSize={{ minRows: 7, maxRows: 18 }}
          maxLength={DESCRIPTION_CHARACTER_LIMIT}
          className={styles.descriptionInput}
          autoFocus
        />
        <div className={styles.descriptionFooter}>
          {`${description.length} / ${DESCRIPTION_CHARACTER_LIMIT}`}
        </div>
      </div>
      <div className={styles.submissionContainer}>
        <Input
          type="email"
          placeholder={strings.feedback_email_placeholder}
          className={styles.emailInput}
          onChange={onEmailChange}
          value={reporterEmail || email}
          disabled={!!reporterEmail}
        />
        <div className={styles.confirmationContainer}>
          <Checkbox
            className={styles.confirmationCheckbox}
            onChange={onCheckboxChange}
            checked={privacyChecked}
          />
          <div>
            <span>{strings.feedback_consent} </span>
            <a href="https://get.bugherd.com/privacy">privacy policy.</a>
          </div>
        </div>
        <Button
          className={cx(styles.createButton, {
            [styles.frenchButton]: locale === 'fr'
          })}
          disabled={!submitEnabled}
          type="primary"
          onClick={submitTask}
        >
          {strings.feedback_submit_text}
        </Button>
      </div>
    </>
  );
};

export default CreateTask;
